import { AxiosResponse } from "axios";
import { BaseService } from "../baseService";
import { HttpMethods } from "../httpMethods";
import { Controllers } from "src/utils/constants";

export interface AicLockStatus {
	isLocked: boolean;
	lockedAt?: string;
	lockTrigger?: number;
	creditConsumptionPercentAtLock?: number;
}

class AicLockingService extends BaseService {
	async getAicLockStatus(): Promise<AxiosResponse<AicLockStatus>> {
		return this.invokeServiceCall(HttpMethods.Get, Controllers.AicLocking, "status");
	}

	async syncAicCredits(): Promise<AxiosResponse<AicLockStatus>> {
		return this.invokeServiceCall(HttpMethods.Post, Controllers.AicLocking, "sync");
	}
}

export const aicLockingService = new AicLockingService();
